const config = {
    host: (process.env.NODE_ENV === 'production') ? 'https://citydrive.dvgeo.app' : 'http://192.168.100.106:3017',
    homePage: (process.env.NODE_ENV === 'production') ? 'https://citydrive.dvgeo.app' : 'http://192.168.100.106:3017',
    api: 'api/',
    apiSocket: 'citydrive::1.2',
    nameDir: 'citydrive',
    package: 'app.dvgeo.citydrive.web',
    version: '1.0.0',
    googleAPIKey: 'AIzaSyB2r9_pDy9Oyw6yCY2MvaWDjA7iEnIz9w8',
    appName: 'CITY DRIVE',
    provider: 'Devjos CIA LTDA',
    colorPrimary: '#96ba35',
    colorDark: '#095b71',
    colorAccent: '#ccc',
    colorTextPrimary: '#fff',
    colorTextDark: '#000',
    playStorePassengerId: 'app.dvgeo.citydrive.passenger',
    playStoreDriverId: 'app.dvgeo.citydrive.driver',
    appStorePassengerId: '6757618342',
    appStoreDriverId: '6757619261',
};
export default config;
